import { Button } from 'system/atoms';
import { useDrawer } from 'services/drawer/hooks';
import { DrawerComponentType } from 'services/drawer/types';
import { useRecoilValue } from 'recoil';
import { organizationConfigAtom } from 'services/organization/atom';

type Props = {
  onSave?: (globalContext: string | undefined) => void;
};

export const GlobalContextButton: React.FC<Props> = ({ onSave }) => {
  const { openDrawer } = useDrawer();
  const organizationConfig = useRecoilValue(organizationConfigAtom);

  const handleOpenGlobalContextDrawer = () => {
    openDrawer({
      drawerContentType: DrawerComponentType.GlobalContextDrawer,
      drawerComponentProps: {
        initialGlobalContext: organizationConfig?.globalContext || '',
        onSave: onSave
      }
    });
  };

  return (
    <Button variant="tertiary" onClick={handleOpenGlobalContextDrawer}>
      Reference material
    </Button>
  );
};
